<template>
  <div>
    <el-popover
      popper-class="sw-dic-type-popover"
      placement="bottom"
      title=""
      width="260"
      trigger="manual"
      v-model="visible"
    >
      <div
        class="infinite-list-wrapper"
        style="overflow: auto; height: 180px"
        v-loading="dicType.loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="#FFF"
      >
        <ul
          class="list sw-remote-select-option"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
        >
          <li
            v-for="item in dicType.list"
            :key="item.type_code"
            @click="selectHandle(item)"
            :class="{ swDicTypeSpan: value.code === item.type_code }"
          >
            <span style="padding-left: 20px">{{ item.type_name }}</span>
            <span v-if="value.code === item.type_code"
              ><i class="el-icon-check sw-dic-type-icon"></i
            ></span>
          </li>
        </ul>
        <p v-if="dicType.isEnd">没有更多了...</p>
      </div>
      <div
        slot="reference"
        class="sw-remote-select-div"
        :class="{ divFocus: visible }"
      >
        <span v-if="value.code" class="span"
          ><span class="sel-name">{{ value.name }}</span
          ><span @click="deleteHandle" class="sel-icon"
            ><i class="el-icon-close"></i></span
        ></span>
        <el-input
          @focus="openPopover"
          @blur="closePopover"
          v-model="inputValue"
          placeholder="请输入字典类型名称"
          class="sw-dic-type-input"
        ></el-input>
      </div>
    </el-popover>
  </div>
</template>

<script>
import widgetConfigUtils from '../../../util/widgetConfigUtils'

export default {
  name: 'dic-type-select',
  props: ['dicType', 'value'],
  data() {
    return {
      inputValue: '',
      visible: false,
      lastTime: new Date().getTime(),
      timeInterval: 1000, // 时间间隔，默认1000 毫秒
    }
  },
  methods: {
    openPopover() {
      this.visible = true
    },
    closePopover() {
      this.visible = false
      this.inputValue = ''
    },
    selectHandle(item) {
      this.value.code = item.type_code
      this.value.name = item.type_name
    },
    deleteHandle() {
      this.value.code = ''
      this.value.name = ''
    },
    searchDic() {
      setTimeout(() => {
        const now = new Date().getTime()
        if (now - this.lastTime >= this.timeInterval) {
          // 计算相隔时间，如果超过 timeInterval 毫秒 没有后续输入，则直接查询接口
          if (this.dicType.name !== this.inputValue) {
            this.dicType.loading = true
            this.dicType.name = this.inputValue
            this.dicType.list = []
            this.dicType.isEnd = false
            this.dicType.page = 1
            widgetConfigUtils.queryDicTypeList(this.dicType)
          }
        }
      }, this.timeInterval)
    },
    load() {
      this.dicType.page++
      widgetConfigUtils.queryDicTypeList(this.dicType)
    },
  },
  watch: {
    inputValue: function () {
      this.lastTime = new Date().getTime()
      this.searchDic()
    },
  },
}
</script>
<style>
.sw-dic-type-popover {
  padding: 0px;
  padding-top: 2px;
}
.sw-remote-select-div {
  border: 1px solid #c0c4cc;
  border-radius: 4px;
}
.sw-remote-select-div .span {
  margin-left: 10px;
  height: 35px;
  background-color: #9b9b9b;
  color: white;
}
.sw-remote-select-div .sel-name {
  margin: 8px;
}
.sw-remote-select-div .sel-icon {
  background-color: rgba(76, 59, 76, 0.61);
  border-radius: 10px;
}
.infinite-list-wrapper p {
  text-align: center;
}
.sw-remote-select-option {
  margin-top: 0px;
  padding-inline-start: 0px;
}
.sw-remote-select-option li {
  list-style: none;
  width: 100%;
  height: 30px;
  line-height: 30px;
  padding-left: -38px;
  text-align: left;
}
.sw-remote-select-option li:hover {
  background-color: #939aa24d;
}
.swDicTypeSpan {
  color: #409eff;
}
.sw-dic-type-icon {
  float: right;
  line-height: 30px;
  margin-right: 20px;
}
.divFocus {
  border-color: #409eff;
}
.sw-dic-type-input .el-input__inner {
  border-style: none;
}
.sw-dic-type-input .el-input__inner:hover {
  border-style: none;
}
.sw-dic-type-input .el-input__inner:focus {
  border-style: none;
}
</style>
